module.exports = __webpack_public_path__ + "img/苏州好特斯.e2537e3e.jpg";